import React from 'react';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import _ from 'lodash';

import { FileField } from '../../../jbc-front/components/Form';
import Button from 'jbc-front/components/Button';
import { Download } from 'jbc-front/components/icons';

import { ErrorsSection } from 'src/components';
import { EMPLOYEE_ATTENDANCE_CSV_FORM } from 'src/constants/FormNames';
import DownloadCsvEncodingRadioButton from 'src/components/DownloadCsvEncodingRadioButton';

import { FormSubmitBtn } from 'src/buttons';
import {
  getImportJobs,
  getClientSyncTasks,
  downloadTemplateCsv,
  importEmployeeAttendanceCsv,
  getEmployeeAttendanceItemErrors
} from 'src/reducers/employees/employeeAttendances';

import { ENCODING_OPTIONS } from 'src/constants/Options';
import { UTF_8 } from 'src/constants/Generals';

import styles from './EmployeeAttendanceDownloadCsvForm.scss';
import { useTranslation } from 'react-i18next';

const EmployeeAttendanceCsvInsideForm = props => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    submitting,
    pristine,
    submit,
    errors,
    downloadCsv,
    clientSyncTasks = {},
    importJobs = {}
  } = props;
  const disabledUpload =
    !_.isEmpty(clientSyncTasks.inProgress) || !_.isEmpty(importJobs.inProgress) || !_.isEmpty(importJobs.waiting);

  return (
    <div className={styles.wrap}>
      <div className={styles.head}>{t('features.EmployeeAttendances.components.EmployeeAttendanceDownloadCsvForm.Upload_steps')}</div>
      <div className={styles.body}>
        <form onSubmit={handleSubmit}>
          <dl className={styles.label}>
            <dt className={styles.number}>1</dt>
            <dd className={styles.detail}>
              {/* <p className={styles.text}>{t('features.EmployeeAttendances.components.EmployeeAttendanceDownloadCsvForm.Select_export_file_format_and_use_the_downloaded_CSV_file')}</p>
              <DownloadCsvEncodingRadioButton
                name={'encoding'}
                label={null}
                options={ENCODING_OPTIONS}
                required={false}
              /> */}
              <Button
                onClick={() => (disabledUpload ? null : downloadCsv())}
                icon={<Download size={16} />}
                widthWide
                disabled={disabledUpload}
              >
                {t('features.EmployeeAttendances.components.EmployeeAttendanceDownloadCsvForm.Download_attendance_information')}
              </Button>
            </dd>
          </dl>

          <dl className={styles.label}>
            <dt className={styles.number}>2</dt>
            <dd className={styles.detail}>
              <p className={styles.text}>
                {t('features.EmployeeAttendances.components.EmployeeAttendanceDownloadCsvForm.Input_data_for_attendance_items_in_the_downloaded_CSV_file_using_the_explanation_below_for_reference')}
              </p>
            </dd>
          </dl>

          <dl className={styles.label}>
            <dt className={styles.number}>3</dt>
            <dd className={styles.detail}>
              <p className={styles.text}>{t('features.EmployeeAttendances.components.EmployeeAttendanceDownloadCsvForm.Select_the_completed_file_and_upload')}</p>
              <FileField name="employee_attendance_csv" accepted="csv" disabled={disabledUpload} />
              {disabledUpload ? <p>{t('features.EmployeeAttendances.components.EmployeeAttendanceDownloadCsvForm.Cannot_edit_because_attendance_information_is_being_updated')}</p> : null}
            </dd>
          </dl>

          <FormSubmitBtn
            text={t('features.EmployeePays.components.EmployeePayDownloadCsvForm.upload')}
            {...{ submitting, pristine, submit }}
            widthWide
            disabled={disabledUpload}
          />

          <ErrorsSection errors={errors} />
        </form>
      </div>
    </div>
  );
};

const EmployeeAttendanceDownloadCsvForm = reduxForm({
  form: EMPLOYEE_ATTENDANCE_CSV_FORM
})(EmployeeAttendanceCsvInsideForm);
const mapStateToProp = (state, ownProps) => ({
  initialValues: { encoding: UTF_8, jobInfo: ownProps.jobInfo },
  errors: getEmployeeAttendanceItemErrors(state),
  clientSyncTasks: getClientSyncTasks(state) || {},
  importJobs: getImportJobs(state) || {}
});
const mapDispatchToProp = dispatch => ({
  onSubmit: data => dispatch(importEmployeeAttendanceCsv(data)),
  downloadCsv: () => dispatch(downloadTemplateCsv())
});

export default connect(mapStateToProp, mapDispatchToProp)(EmployeeAttendanceDownloadCsvForm);
